import {Outlet} from 'react-router';

import {ViewModelProvider} from './ViewModelContext';

const AddKidPageContent = () => {
  return <Outlet />;
};

const AddKidPage = () => (
  <ViewModelProvider>
    <AddKidPageContent />
  </ViewModelProvider>
);

export default AddKidPage;
